export default __webpack_public_path__ + "static/media/gps_off.79c71b1f.svg";